const validate = values => {
  const errors = {}

  // Email name
  if (!values?.emailName) {
    errors.emailName = "The email name is required"
  }

  // Subject
  if (!values?.subject) {
    errors.subject = "The subject is required"
  }

  // Message
  if (!values?.message) {
    errors.message = "The message is required"
  }

  // To
  if (!values?.composeEmail || values?.composeEmail.length === 0) {
    errors.composeEmail =
      "You must check one option and select at least one experience/user/tag if you have selected one of the 3 checkboxes"
  } else if (
    values?.composeEmail?.includes("Individual users") &&
    (!values?.userSearch || values?.userSearch?.length === 0)
  ) {
    errors.userSearch = "Required"
  } else if (
    values?.composeEmail?.includes("Users in specific experiences") &&
    (!values?.experienceSearch || values?.experienceSearch?.length === 0)
  ) {
    errors.experienceSearch = "Required"
  } else if (
    values?.composeEmail?.includes("Tagged users") &&
    (!values?.tagSearch || values?.tagSearch?.length === 0)
  ) {
    errors.tagSearch = "Required"
  }

  //Scheduled send
  //time
  if (values?.date && !values?.time) {
    errors.time = "The time is required if you selected the date"
  }

  //timezone
  if (values?.date && !values?.timeZone) {
    errors.timeZone = "The timezone is required"
  }

  return errors
}

export default validate
